import { useState, useEffect } from 'react';
import axios from 'axios';
import Room from '../components/Room';
import '../styles/styles.css';
import SearchBar from '../components/home/SearchBar';

export default function Apartaments() {
  const [ data, setData ] = useState(null);

  async function getData() {
    try {
      await axios({
        method: 'get',
        // url: 'http://localhost:3002/api/rooms'
        url: 'https://sunnydays-backend-c82612a62427.herokuapp.com/api/rooms'
      }).then(response => setData(response.data))
    } catch(error) {
      console.log(error)
    }
  }

  useEffect( () => {
    getData();
  }, []);

  const LoadingTabs = () => (
    <>
      <div className='skeleton-tab'/>
      <div className='skeleton-tab'/>
      <div className='skeleton-tab'/>
      <div className='skeleton-tab'/>
    </>
  )

  const Rooms = ({data}) => { return data && data.slice(0, 4).map((item, index) => <Room key={index} data={item}/>) }

  return (
    <div className='dev-home'>
      <SearchBar/>
      <div className='dev-apartaments-list'>
        <div className='dev-aparts-heading'>
          <h2>Nasze apartamenty</h2>
          <a href="/apartamenty">Zobacz wszystkie</a>
        </div>
        <div className='list all'>
          {!data ? <LoadingTabs/> : <Rooms data={data}/>}
        </div>
      </div>
    </div>
  );
};